import { Table } from "@pentabd/ui";

type ManpowerTableProps = {
  column: any;
  rows: any;
  height?: number;
};

export const ManpowerTable = ({ column, rows, height }: ManpowerTableProps) => {
  return (
    <Table
      columns={column || []}
      rows={rows || []}
      isStickyHeader
      {...(height && { height })}
    />
  );
};
